import { useCallback, useMemo } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import { isCompleted } from '@alltrails/modules/Lists/listUtils';
import { type ListsState, toggleListItem } from '@alltrails/redux/slices/lists';
import type TrailId from '@alltrails/core/types/TrailId';
import { useDispatch, useSelector } from 'react-redux';

const MAGIC_ID_COMPLETED = 1001;

const useTrailCompleted = (trailId: TrailId) => {
  const dispatch = useDispatch();
  const user = useUser();
  const listItems = useSelector((state: { lists: ListsState }) => state.lists.listItems);

  const completed = useMemo(() => isCompleted(listItems, 'trail', trailId), [listItems, trailId]);

  const toggleTrailCompleted = useCallback(() => {
    if (!user) {
      return;
    }

    dispatch(
      toggleListItem({
        userId: user.id,
        listId: MAGIC_ID_COMPLETED,
        type: 'trail',
        objectId: trailId
      })
    );
  }, [user, dispatch, trailId]);

  return { completed, toggleTrailCompleted };
};

export default useTrailCompleted;
